import React, { useEffect, useRef, useState } from 'react';
import styles from '../css/privacy.module.css'
import { postAsync } from '../utils/httpClient';
import { CircularProgress } from '@mui/material';

const Privacy = () => {
  // render 가 되는즉시 2번을 호출하기때문에
  // ref 속성을이용해 한번만 호출하게 설정
  const renderRef = useRef(true);
  const [privacy, setPrivacy] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false; // 첫 렌더링 이후에는 두번 호출되지 않도록 설정
      postAsync('/v2/terms/service', {})
        .then((res) => {
          setPrivacy(res.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setLoading(true);
        });
    }
  }, []);

  return (
    <div className={styles.wrapper} style={{ height: loading ? '100vh' : 'auto' }}>
        {/* 제목 */}
        <h2 className={styles.title}>
          {privacy?.termsTitle}
        </h2>

        {/* 내용 */}
        <div className={styles.contents}
          style={{
            display: loading ? 'flex' : 'block',
            justifyContent: loading ? 'center' : 'unset',
          }}
        >
          {loading ? (  // 로딩 상태일때  mui 로딩 스피너 (api의 데이터가 불러오기전까지 로딩상태 설정)
            <CircularProgress color="inherit" />
          ) : (
            (<div dangerouslySetInnerHTML={{__html: privacy?.termsContents}}/>)
          )}
        </div>
    </div>
  );
}

export default Privacy;
